<template>
  <cvt-dialog
    v-if="!AltPopupManager"
    size="lg"
    bg-color="#fff"
    :show="show"
    :show-close="false"
    :height-auto="true"
    :show-header="false"
    :show-footer="false"
  >
    <div class="row mb-4 mt-4">
      <div class="col-md-10 text-center mx-auto">
        <h1 class="setup-title" :style="titleStyle">
          {{ $t('setup.message.title') }}
        </h1>
      </div>
    </div>
    <div class="row mb-4">
      <div class="col-md-10 text-center mx-auto">
        <h5 :style="titleStyle">{{ $t('setup.message.description') }}</h5>
      </div>
    </div>

    <div class="row mb-2">
      <div class="col-md-10 mx-auto">
        <cvt-input
          id="templateNameId"
          v-model="siteName"
          v-validate="validateSiteName"
          type="text"
          name="name"
          :label="$t('settings.page.label')"
          :clearable="false"
          :validation-status="nameInvalid ? 'invalid' : 'valid'"
          :valid-message="$t('settings.page.validation')"
          :invalid-message="$t('setup.template.name')"
        />
        <div v-show="nameInvalid" class="invalid-feedback">
          {{ $t('setup.template.name') }}
        </div>
      </div>
    </div>
    <div class="row mb-4">
      <div class="mx-auto">
        <cvt-button
          size="md"
          color="primary"
          text="Continue"
          theme="light"
          :outlined="false"
          :full-width="true"
          :disabled="nameInvalid"
          @click="$emit('continue')"
        />
      </div>
    </div>
  </cvt-dialog>
  <cvt-dialog
    v-else
    bg-color="#ffffff"
    size="sm"
    :show="show"
    :show-close="false"
    :height-auto="true"
    :show-header="false"
    :show-footer="false"
  >
    <div class="row mb-2 mt-4">
      <div class="col-md-12">
        <h5 class="setup-title" :style="titleStyle">
          {{ $t('setup.message.title') }}
        </h5>
      </div>
    </div>
    <div class="row mb-2">
      <div class="col-md-12">
        <cvt-input
          v-model="siteName"
          v-validate="validateSiteName"
          type="text"
          name="name"
          :label="$t('settings.page.label')"
          :clearable="false"
          :validation-status="nameInvalid ? 'invalid' : 'valid'"
          :valid-message="$t('settings.page.validation')"
          :invalid-message="$t('setup.template.name')"
        />
        <div v-show="nameInvalid" class="invalid-feedback">
          {{ $t('setup.template.name') }}
        </div>
      </div>
    </div>
    <div class="row">
      <div class="ml-auto mr-3">
        <cvt-button
          size="sm"
          color=""
          text="Continue"
          theme="light"
          special-style="dark"
          :outlined="true"
          :full-width="true"
          :disabled="nameInvalid"
          @click="$emit('continue')"
        />
      </div>
    </div>
  </cvt-dialog>
</template>

<script>
import * as _ from 'lodash'
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
import * as actions from '../../../store/modules/actions'
import * as getters from '../../../store/modules/getters'
import * as mutations from '../../../store/modules/mutations'
export default {
  components: {},
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      validateSiteName: {
        rules: {
          required: true,
          min: 3,
        },
      },
      mode: 'LIGHT',
      prependChevron: false,
    }
  },
  computed: {
    ...mapGetters({
      site: getters.SITE_GET_DATA,
      step: getters.STEPS_CURRENT_STEP,
      fontStyles: getters.THEME_FONT_STYLES,
      brandLogo: getters.THEME_BRAND_LOGO,
    }),
    ...mapState('globalTheme', {
      FontFamily: ({ globalTheme }) => globalTheme.FontFamily,
      AltPopupManager: ({ globalTheme }) =>
        globalTheme.AltPopupManager !== undefined
          ? globalTheme.AltPopupManager
          : false,
    }),
    nameInvalid() {
      let invalid = this.errors.has('name')
      this.blockNextStep(invalid)
      return invalid
    },
    titleStyle() {
      return { 'font-family': this.FontFamily.DEFAULT }
    },
    siteName: {
      get() {
        return this.site.name
      },
      set: _.debounce(
        function ({ target }) {
          this.updateSite({
            ...this.site,
            name: target.value,
          })
          return target.value
        },
        700,
        { trailing: true },
      ),
    },
  },
  mounted() {
    // setTimeout(() => {
    //   this.$el.querySelector('.form-control').focus()
    //   this.$validator.validate()
    // }, 0)
  },
  methods: {
    ...mapActions({
      updateSite: actions.SITE_UPDATE,
    }),
    ...mapMutations({
      blockNextStep: mutations.STEPS_BLOCK,
    }),
  },
}
</script>

<style lang="scss">
.step-one-setup {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding-top: 50px;
}

.step-one-setup__input {
  width: 500px;
  margin-top: 50px;
  margin-bottom: 50px;
}

.setup-title {
  font-weight: bold;
}

.modal__body {
  background-color: #fff;
}
</style>
